module.exports = __webpack_public_path__ + "assets/images/scream-8ae45e40e17b8cfc949dfa2a30d2b28e.png";